import { createFileRoute } from '@tanstack/react-router';

import { batchAssignmentNewScreen, batchAssignmentNewSearch, loadBatchAssignmentMessages, loadBatchAssignmentNewScreen } from '@/modules/batch-assignment/route';
import { lazyScreen } from '@/shared/screen';

// Nova cessão (`router.tsx:1250-1254`): o fluxo com o passo em `?passo=` (F5).
export const Route = createFileRoute('/_app/ccb/cessoes/nova')({
  validateSearch: batchAssignmentNewSearch,
  staticData: { screen: batchAssignmentNewScreen },
  loader: loadBatchAssignmentMessages,
  component: lazyScreen(loadBatchAssignmentNewScreen, 'BatchAssignmentNewScreen'),
});
